import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

const containerVariants = (delay) => ({
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.13, delayChildren: delay },
  },
});

const lineVariants = {
  hidden: { y: "112%" },
  visible: { y: "0%", transition: { duration: 0.95, ease: EASE } },
};

export const MaskedLines = ({
  lines,
  as: Tag = "span",
  className = "",
  lineClass = "",
  delay = 0,
  scroll = false,
}) => (
  <Tag
    className={className}
    variants={containerVariants(delay)}
    initial="hidden"
    {...(scroll
      ? { whileInView: "visible", viewport: { once: true, amount: 0.25 } }
      : { animate: "visible" })}
  >
    {lines.map((line, i) => (
      <span key={i} className="-mb-[0.12em] block overflow-hidden pb-[0.12em]">
        <motion.span
          className={`block will-change-transform ${lineClass}`}
          variants={lineVariants}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </Tag>
);

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ eyebrow, lines, sub, center = false, dark = false }) => (
  <div className={center ? "text-center" : ""}>
    <Reveal y={14}>
      <p
        className={`font-body text-xs font-extrabold uppercase tracking-[0.3em] ${dark ? "text-gold" : "text-brand"}`}
        data-testid="section-eyebrow"
      >
        {eyebrow}
      </p>
    </Reveal>
    <MaskedLines
      as="h2"
      scroll
      lines={lines}
      className={`mt-4 block font-display text-3xl font-black leading-[1.12] tracking-tight ${dark ? "text-snow" : "text-cocoa"} ${center ? "mx-auto" : ""}`}
    />
    {sub && (
      <Reveal delay={0.15} y={16}>
        <p className={`mt-5 max-w-xl font-semibold leading-relaxed ${dark ? "text-blush" : "text-rose"} ${center ? "mx-auto" : ""}`}>{sub}</p>
      </Reveal>
    )}
  </div>
);
